export const actAiExtractionSchema = {
    type: 'object',
    additionalProperties: false,
    required: [
        'organ',
        'sessionType',
        'date',
        'subject',
        'resolutions',
        'effectiveFrom',
        'effectiveTo',
        'documentNumberFound',
        'warnings',
        'evidence',
    ],
    properties: {
        organ: {
            type: ['string', 'null'],
            enum: ['general_assembly', 'administration_council', 'surveillance_council', null],
        },
        sessionType: {
            type: ['string', 'null'],
            enum: ['ordinary', 'extraordinary', 'informative', null],
        },
        date: { type: ['string', 'null'] },
        subject: { type: ['string', 'null'] },
        resolutions: { type: ['string', 'null'] },
        effectiveFrom: { type: ['string', 'null'] },
        effectiveTo: { type: ['string', 'null'] },
        documentNumberFound: { type: ['string', 'null'] },
        warnings: { type: 'array', items: { type: 'string' } },
        evidence: {
            type: 'array',
            items: {
                type: 'object',
                additionalProperties: false,
                required: ['field', 'page', 'excerpt'],
                properties: {
                    field: { type: 'string' },
                    page: { type: ['integer', 'null'] },
                    excerpt: { type: 'string' },
                },
            },
        },
    },
};
const nullableString = (value) => value === null || typeof value === 'string';
export function isActAiExtractionResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const response = value;
    const proposal = response.proposal;
    return (typeof response.extractionId === 'string' &&
        typeof response.model === 'string' &&
        response.requiresHumanReview === true &&
        !!proposal &&
        (proposal.organ === null ||
            proposal.organ === 'general_assembly' ||
            proposal.organ === 'administration_council' ||
            proposal.organ === 'surveillance_council') &&
        (proposal.sessionType === null ||
            proposal.sessionType === 'ordinary' ||
            proposal.sessionType === 'extraordinary' ||
            proposal.sessionType === 'informative') &&
        nullableString(proposal.date) &&
        nullableString(proposal.subject) &&
        nullableString(proposal.resolutions) &&
        nullableString(proposal.effectiveFrom) &&
        nullableString(proposal.effectiveTo) &&
        nullableString(proposal.documentNumberFound) &&
        Array.isArray(proposal.warnings) &&
        proposal.warnings.every((item) => typeof item === 'string') &&
        Array.isArray(proposal.evidence) &&
        proposal.evidence.every((item) => typeof item === 'object' &&
            item !== null &&
            typeof item.field === 'string' &&
            (typeof item.page === 'number' ||
                item.page === null) &&
            typeof item.excerpt === 'string'));
}
